import React, { useState, useRef } from "react";
//import { useUser } from "../UserContext";
import "./index.css";

const SECOES = [
  { id: "empresa", label: "Dados da Empresa" },
  { id: "endereco", label: "Endereço" },
  { id: "contato", label: "Contato" },
  { id: "fiscal", label: "Fiscal / Certificado" },
  { id: "visual", label: "Logo" },
];

const UFS = [
  "AC","AL","AP","AM","BA","CE","DF","ES","GO","MA","MT","MS","MG","PA","PB",
  "PR","PE","PI","RJ","RN","RS","RO","RR","SC","SP","SE","TO",
];

const maskCnpj = (v) => {
  return v
    .replace(/\D/g, "")
    .slice(0, 14)
    .replace(/(\d{2})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1/$2")
    .replace(/(\d{4})(\d{1,2})$/, "$1-$2");
};

const maskCep = (v) => {
  return v.replace(/\D/g, "").slice(0, 8).replace(/(\d{5})(\d)/, "$1-$2");
};

const maskFone = (v) => {
  const digits = v.replace(/\D/g, "").slice(0, 11);
  if (digits.length <= 10) {
    return digits.replace(/(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3").trim();
  }
  return digits.replace(/(\d{2})(\d{5})(\d{0,4})/, "($1) $2-$3").trim();
};

const estadoInicial = {
  cnpj: "",
  tipoCnpj: "simples", // simples | mei
  inscricaoEstadual: "",
  razao: "",
  fantasia: "",
  rua: "",
  numero: "",
  complemento: "",
  bairro: "",
  cidade: "",
  uf: "",
  cep: "",
  codigoIbge: "",
  fone: "",
  celular: "",
  site: "",
  email: "",
  emailContabilidade: "",
  senhaCertificado: "",
  ultimoNumeroNota: "",
  serie: "",
  chaveCsc: "",
  tokenCsc: "",
};

export default function ModalConfig({ onClose }) {
  //const { userInfo } = useUser();
  const [secaoAtiva, setSecaoAtiva] = useState("empresa");
  const [form, setForm] = useState(estadoInicial);
  const [logoPreview, setLogoPreview] = useState(null);
  const [logoFile, setLogoFile] = useState(null);
  const [certificadoFile, setCertificadoFile] = useState(null);
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [buscandoCep, setBuscandoCep] = useState(false);
  const [erroCep, setErroCep] = useState("");
  const [salvando, setSalvando] = useState(false);
  const [erros, setErros] = useState({});

  const inputLogoRef = useRef(null);
  const inputCertRef = useRef(null);

  const atualizarCampo = (campo, valor) => {
    setForm((prev) => ({ ...prev, [campo]: valor }));
    setErros((prev) => ({ ...prev, [campo]: undefined }));
  };

  // ---------- Busca automática de endereço por CEP ----------
  const buscarCep = async (cepDigitado) => {
    const cepLimpo = cepDigitado.replace(/\D/g, "");
    if (cepLimpo.length !== 8) return;

    try {
      setBuscandoCep(true);
      setErroCep("");

      const res = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);
      const json = await res.json();

      if (json.erro) {
        setErroCep("CEP não encontrado.");
        return;
      }

      setForm((prev) => ({
        ...prev,
        rua: json.logradouro || prev.rua,
        bairro: json.bairro || prev.bairro,
        cidade: json.localidade || prev.cidade,
        uf: json.uf || prev.uf,
        codigoIbge: json.ibge || prev.codigoIbge,
      }));
    } catch (err) {
      console.error("Erro ao buscar CEP:", err);
      setErroCep("Erro ao buscar CEP.");
    } finally {
      setBuscandoCep(false);
    }
  };

  const handleCepChange = (e) => {
    const valor = maskCep(e.target.value);
    atualizarCampo("cep", valor);
    if (valor.replace(/\D/g, "").length === 8) {
      buscarCep(valor);
    }
  };

  // ---------- Upload de logo ----------
  const handleLogoChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      alert("Selecione um arquivo de imagem válido.");
      return;
    }

    setLogoFile(file);
    const reader = new FileReader();
    reader.onload = () => setLogoPreview(reader.result);
    reader.readAsDataURL(file);
  };

  const removerLogo = () => {
    setLogoFile(null);
    setLogoPreview(null);
    if (inputLogoRef.current) inputLogoRef.current.value = "";
  };

  // ---------- Upload de certificado ----------
  const handleCertificadoChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const extensoesValidas = [".pfx", ".p12"];
    const valido = extensoesValidas.some((ext) => file.name.toLowerCase().endsWith(ext));

    if (!valido) {
      alert("Selecione um arquivo de certificado válido (.pfx ou .p12).");
      return;
    }

    setCertificadoFile(file);
  };

  const removerCertificado = () => {
    setCertificadoFile(null);
    if (inputCertRef.current) inputCertRef.current.value = "";
  };

  // ---------- Validação ----------
  const validar = () => {
    const novosErros = {};

    if (!form.cnpj || form.cnpj.replace(/\D/g, "").length !== 14) {
      novosErros.cnpj = "CNPJ inválido.";
    }

    if (form.tipoCnpj === "simples" && !form.inscricaoEstadual.trim()) {
      novosErros.inscricaoEstadual = "Obrigatório para regime Simples Nacional.";
    }

    if (!form.razao.trim()) novosErros.razao = "Campo obrigatório.";
    if (!form.fantasia.trim()) novosErros.fantasia = "Campo obrigatório.";
    if (!form.cep.trim()) novosErros.cep = "Campo obrigatório.";
    if (!form.cidade.trim()) novosErros.cidade = "Campo obrigatório.";
    if (!form.uf.trim()) novosErros.uf = "Selecione a UF.";

    if (form.email && !/\S+@\S+\.\S+/.test(form.email)) {
      novosErros.email = "E-mail inválido.";
    }

    setErros(novosErros);

    // Se algum erro estiver em outra seção, avisa pra qual seção ir
    if (Object.keys(novosErros).length > 0) {
      const camposFiscal = ["chaveCsc", "tokenCsc", "senhaCertificado", "ultimoNumeroNota", "serie"];
      const camposEndereco = ["cep", "cidade", "uf", "rua", "numero", "bairro"];
      const primeiroErro = Object.keys(novosErros)[0];

      if (camposFiscal.includes(primeiroErro)) setSecaoAtiva("fiscal");
      else if (camposEndereco.includes(primeiroErro)) setSecaoAtiva("endereco");
      else setSecaoAtiva("empresa");
    }

    return Object.keys(novosErros).length === 0;
  };

  // ---------- Salvar (endpoint ainda não definido) ----------
  const salvar = async () => {
    if (!validar()) return;

    try {
      setSalvando(true);

      const payload = new FormData();
      Object.entries(form).forEach(([key, value]) => payload.append(key, value));
      if (logoFile) payload.append("logo", logoFile);
      if (certificadoFile) payload.append("certificado", certificadoFile);

      // TODO: substituir pela chamada real quando o endpoint estiver disponível
      // await fetch(`${userInfo.url}/empresa/configuracoes`, {
      //   method: "POST",
      //   headers: {
      //     empresa: userInfo.alias,
      //     Authorization: `Basic ${btoa(`${userInfo.alias};${userInfo.venLogin}:${userInfo.venSenha}`)}`,
      //   },
      //   body: payload,
      // });

      console.log("Payload pronto para envio:", Object.fromEntries(payload.entries()));
      alert("Configurações validadas! (endpoint de salvamento ainda será integrado)");
    } catch (err) {
      console.error("Erro ao salvar configurações:", err);
      alert("Erro ao salvar configurações.");
    } finally {
      setSalvando(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-box modal-config-empresa">
        <div className="modal-header">
          <h3>Configurações da Empresa</h3>
          <button className="btn-close" onClick={onClose}>✕</button>
        </div>

        <div className="cfg-body">
          {/* ---------- Menu lateral de seções ---------- */}
          <div className="cfg-sidebar">
            {SECOES.map((s) => (
              <button
                key={s.id}
                className={`cfg-menu-item ${secaoAtiva === s.id ? "ativo" : ""}`}
                onClick={() => setSecaoAtiva(s.id)}
              >
                {s.label}
              </button>
            ))}
          </div>

          {/* ---------- Conteúdo da seção ---------- */}
          <div className="cfg-content">
            {secaoAtiva === "empresa" && (
              <div className="cfg-secao">
                <div className="cfg-grid">
                  <div className="cfg-campo">
                    <label>CNPJ *</label>
                    <input
                      type="text"
                      value={form.cnpj}
                      onChange={(e) => atualizarCampo("cnpj", maskCnpj(e.target.value))}
                      placeholder="00.000.000/0000-00"
                      className={erros.cnpj ? "erro" : ""}
                    />
                    {erros.cnpj && <span className="cfg-erro-msg">{erros.cnpj}</span>}
                  </div>

                  <div className="cfg-campo">
                    <label>Tipo de Regime *</label>
                    <div className="cfg-radio-group">
                      <label className="cfg-radio">
                        <input
                          type="radio"
                          name="tipoCnpj"
                          value="simples"
                          checked={form.tipoCnpj === "simples"}
                          onChange={(e) => atualizarCampo("tipoCnpj", e.target.value)}
                        />
                        Simples Nacional
                      </label>
                      <label className="cfg-radio">
                        <input
                          type="radio"
                          name="tipoCnpj"
                          value="mei"
                          checked={form.tipoCnpj === "mei"}
                          onChange={(e) => atualizarCampo("tipoCnpj", e.target.value)}
                        />
                        MEI
                      </label>
                    </div>
                  </div>

                  <div className="cfg-campo">
                    <label>
                      Inscrição Estadual {form.tipoCnpj === "simples" && "*"}
                    </label>
                    <input
                      type="text"
                      value={form.inscricaoEstadual}
                      onChange={(e) => atualizarCampo("inscricaoEstadual", e.target.value)}
                      placeholder="000.000.000.000"
                      className={erros.inscricaoEstadual ? "erro" : ""}
                    />
                    {erros.inscricaoEstadual && (
                      <span className="cfg-erro-msg">{erros.inscricaoEstadual}</span>
                    )}
                  </div>

                  <div className="cfg-campo cfg-campo-full">
                    <label>Razão Social *</label>
                    <input
                      type="text"
                      value={form.razao}
                      onChange={(e) => atualizarCampo("razao", e.target.value)}
                      placeholder="Razão social completa"
                      className={erros.razao ? "erro" : ""}
                    />
                    {erros.razao && <span className="cfg-erro-msg">{erros.razao}</span>}
                  </div>

                  <div className="cfg-campo cfg-campo-full">
                    <label>Nome Fantasia *</label>
                    <input
                      type="text"
                      value={form.fantasia}
                      onChange={(e) => atualizarCampo("fantasia", e.target.value)}
                      placeholder="Nome fantasia"
                      className={erros.fantasia ? "erro" : ""}
                    />
                    {erros.fantasia && <span className="cfg-erro-msg">{erros.fantasia}</span>}
                  </div>
                </div>
              </div>
            )}

            {secaoAtiva === "endereco" && (
              <div className="cfg-secao">
                <div className="cfg-grid">
                  <div className="cfg-campo">
                    <label>CEP *</label>
                    <div className="cfg-input-loading">
                      <input
                        type="text"
                        value={form.cep}
                        onChange={handleCepChange}
                        placeholder="00000-000"
                        className={erros.cep ? "erro" : ""}
                      />
                      {buscandoCep && <span className="cfg-spinner" />}
                    </div>
                    {erroCep && <span className="cfg-erro-msg">{erroCep}</span>}
                    {erros.cep && <span className="cfg-erro-msg">{erros.cep}</span>}
                  </div>

                  <div className="cfg-campo">
                    <label>Código IBGE</label>
                    <input type="text" value={form.codigoIbge} readOnly placeholder="Auto" />
                  </div>

                  <div className="cfg-campo cfg-campo-full">
                    <label>Rua / Logradouro</label>
                    <input
                      type="text"
                      value={form.rua}
                      onChange={(e) => atualizarCampo("rua", e.target.value)}
                    />
                  </div>

                  <div className="cfg-campo">
                    <label>Número</label>
                    <input
                      type="text"
                      value={form.numero}
                      onChange={(e) => atualizarCampo("numero", e.target.value)}
                    />
                  </div>

                  <div className="cfg-campo">
                    <label>Complemento</label>
                    <input
                      type="text"
                      value={form.complemento}
                      onChange={(e) => atualizarCampo("complemento", e.target.value)}
                    />
                  </div>

                  <div className="cfg-campo">
                    <label>Bairro</label>
                    <input
                      type="text"
                      value={form.bairro}
                      onChange={(e) => atualizarCampo("bairro", e.target.value)}
                    />
                  </div>

                  <div className="cfg-campo">
                    <label>Cidade *</label>
                    <input
                      type="text"
                      value={form.cidade}
                      onChange={(e) => atualizarCampo("cidade", e.target.value)}
                      className={erros.cidade ? "erro" : ""}
                    />
                    {erros.cidade && <span className="cfg-erro-msg">{erros.cidade}</span>}
                  </div>

                  <div className="cfg-campo">
                    <label>UF *</label>
                    <select
                      value={form.uf}
                      onChange={(e) => atualizarCampo("uf", e.target.value)}
                      className={erros.uf ? "erro" : ""}
                    >
                      <option value="">Selecione</option>
                      {UFS.map((uf) => (
                        <option key={uf} value={uf}>{uf}</option>
                      ))}
                    </select>
                    {erros.uf && <span className="cfg-erro-msg">{erros.uf}</span>}
                  </div>
                </div>
              </div>
            )}

            {secaoAtiva === "contato" && (
              <div className="cfg-secao">
                <div className="cfg-grid">
                  <div className="cfg-campo">
                    <label>Telefone</label>
                    <input
                      type="text"
                      value={form.fone}
                      onChange={(e) => atualizarCampo("fone", maskFone(e.target.value))}
                      placeholder="(00) 0000-0000"
                    />
                  </div>

                  <div className="cfg-campo">
                    <label>Celular</label>
                    <input
                      type="text"
                      value={form.celular}
                      onChange={(e) => atualizarCampo("celular", maskFone(e.target.value))}
                      placeholder="(00) 00000-0000"
                    />
                  </div>

                  <div className="cfg-campo cfg-campo-full">
                    <label>Site</label>
                    <input
                      type="text"
                      value={form.site}
                      onChange={(e) => atualizarCampo("site", e.target.value)}
                      placeholder="https://www.suaempresa.com.br"
                    />
                  </div>

                  <div className="cfg-campo cfg-campo-full">
                    <label>E-mail</label>
                    <input
                      type="email"
                      value={form.email}
                      onChange={(e) => atualizarCampo("email", e.target.value)}
                      placeholder="contato@suaempresa.com.br"
                      className={erros.email ? "erro" : ""}
                    />
                    {erros.email && <span className="cfg-erro-msg">{erros.email}</span>}
                  </div>

                  <div className="cfg-campo cfg-campo-full">
                    <label>E-mail da Contabilidade</label>
                    <input
                      type="email"
                      value={form.emailContabilidade}
                      onChange={(e) => atualizarCampo("emailContabilidade", e.target.value)}
                      placeholder="contabilidade@escritorio.com.br"
                    />
                  </div>
                </div>
              </div>
            )}

            {secaoAtiva === "fiscal" && (
              <div className="cfg-secao">
                <div className="cfg-grid">
                  <div className="cfg-campo cfg-campo-full">
                    <label>Certificado Digital (.pfx / .p12)</label>
                    <div className="cfg-file-upload">
                      <input
                        ref={inputCertRef}
                        type="file"
                        accept=".pfx,.p12"
                        onChange={handleCertificadoChange}
                        id="input-certificado"
                        hidden
                      />
                      <label htmlFor="input-certificado" className="cfg-file-btn">
                        📄 Selecionar arquivo
                      </label>
                      {certificadoFile && (
                        <div className="cfg-file-info">
                          <span>{certificadoFile.name}</span>
                          <button onClick={removerCertificado} title="Remover">✕</button>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="cfg-campo">
                    <label>Senha do Certificado</label>
                    <div className="cfg-senha-wrapper">
                      <input
                        type={mostrarSenha ? "text" : "password"}
                        value={form.senhaCertificado}
                        onChange={(e) => atualizarCampo("senhaCertificado", e.target.value)}
                        placeholder="••••••••"
                      />
                      <button
                        type="button"
                        className="cfg-toggle-senha"
                        onClick={() => setMostrarSenha((v) => !v)}
                      >
                        {mostrarSenha ? "🙈" : "👁"}
                      </button>
                    </div>
                  </div>

                  <div className="cfg-campo">
                    <label>Último Número de Nota</label>
                    <input
                      type="number"
                      value={form.ultimoNumeroNota}
                      onChange={(e) => atualizarCampo("ultimoNumeroNota", e.target.value)}
                      placeholder="0"
                    />
                  </div>

                  <div className="cfg-campo">
                    <label>Série</label>
                    <input
                      type="text"
                      value={form.serie}
                      onChange={(e) => atualizarCampo("serie", e.target.value)}
                      placeholder="1"
                    />
                  </div>

                  <div className="cfg-campo cfg-campo-full">
                    <label>Chave CSC (NFC-e)</label>
                    <input
                      type="text"
                      value={form.chaveCsc}
                      onChange={(e) => atualizarCampo("chaveCsc", e.target.value)}
                      placeholder="Identificador CSC"
                    />
                  </div>

                  <div className="cfg-campo cfg-campo-full">
                    <label>Token CSC</label>
                    <input
                      type="text"
                      value={form.tokenCsc}
                      onChange={(e) => atualizarCampo("tokenCsc", e.target.value)}
                      placeholder="Token do Código de Segurança do Contribuinte"
                    />
                  </div>
                </div>
              </div>
            )}

            {secaoAtiva === "visual" && (
              <div className="cfg-secao">
                <div className="cfg-logo-area">
                  <div className="cfg-logo-preview">
                    {logoPreview ? (
                      <img src={logoPreview} alt="Logo da empresa" />
                    ) : (
                      <span className="cfg-logo-placeholder">Sem logo</span>
                    )}
                  </div>

                  <div className="cfg-logo-actions">
                    <input
                      ref={inputLogoRef}
                      type="file"
                      accept="image/*"
                      onChange={handleLogoChange}
                      id="input-logo"
                      hidden
                    />
                    <label htmlFor="input-logo" className="cfg-file-btn">
                      🖼 Escolher imagem
                    </label>
                    {logoPreview && (
                      <button className="cfg-remove-logo" onClick={removerLogo}>
                        Remover logo
                      </button>
                    )}
                    <p className="cfg-logo-hint">Recomendado: PNG ou JPG, fundo transparente, até 2MB.</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="cfg-footer">
          <button className="btn-cancelar" onClick={onClose}>Cancelar</button>
          <button className="btn-salvar" onClick={salvar} disabled={salvando}>
            {salvando ? "Salvando..." : "Salvar Configurações"}
          </button>
        </div>
      </div>
    </div>
  );
}